module.exports = __webpack_public_path__ + "media/icons/close-orange-4be8e72d.svg";